import { Dialog, SelectionMode, useFieldContext } from "@bps/fluent-ui";

import { RolloutPackageFormValues } from "../../rollout/rolloutFormValues";
import { SelectSoftwarePackage } from "./SelectSoftwarePackage";
import { SelectSoftwarePackageFormValues } from "./selectSoftwarePackageUtils";

interface AddRolloutPackageDialogProps {
  onDismiss: () => void;
}

export const AddRolloutPackageDialog: React.FC<AddRolloutPackageDialogProps> = ({
  onDismiss,
  ...props
}) => {
  const { value: rolloutPackages = [], setFieldValue } = useFieldContext<
    RolloutPackageFormValues[]
  >("rolloutPackages");

  const onAdd = (newPackages: SelectSoftwarePackageFormValues[]) => {
    setFieldValue([
      ...rolloutPackages,
      ...newPackages.map(newPackage => {
        const { softwarePackageId, softwarePackageVersionId } = newPackage;
        return {
          softwarePackageId,
          softwarePackageVersionId
        } as RolloutPackageFormValues;
      })
    ]);
  };

  return (
    <Dialog
      hidden={false}
      dialogContentProps={{
        showCloseButton: true,
        title: "Add Software Package"
      }}
      minWidth="90%"
      maxWidth="90%"
      onDismiss={onDismiss}
      {...props}
    >
      <SelectSoftwarePackage
        onDismiss={onDismiss}
        onAdd={onAdd}
        rolloutPackages={rolloutPackages ?? []}
        selectionMode={SelectionMode.multiple}
      />
    </Dialog>
  );
};
